import React from "react";
import ReactDOM from "react-dom/client";
import { Capacitor, SystemBars, SystemBarsStyle, SystemBarType } from "@capacitor/core";
import App from "./App";
import { clearExportCache } from "./nativeApp";

// The phone app draws right to the screen's edges (capacitor.config.json:
// contentInset "never") and keeps its own content clear of the notch and
// the home bar. iOS's automatic insets did that job before, but laid the
// page out before it knew the insets and left it zoomed in until a text
// box was tapped. Pinch-zoom is off in the app for the same reason: a
// stuck zoom is worse than none, and the app's text is sized for phones.
// The website is untouched.
if (Capacitor.isNativePlatform()) {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover");
  }
  document.documentElement.classList.add("native-app");
  const style = document.createElement("style");
  style.textContent = `
    /* The status bar sits over the app: a band in the app's green behind
       it, so its white text can always be read. Screens with their own
       green top bar cover this with it. */
    html.native-app body::before {
      content: ""; position: fixed; top: 0; left: 0; right: 0;
      height: env(safe-area-inset-top, 0px);
      background: #1a4a2e; z-index: 250; pointer-events: none;
    }
  `;
  document.head.appendChild(style);
  // Android picks the colour of the status bar's clock and icons from the
  // phone's light/dark setting, which on a light phone means dark icons on
  // that green band: hard to read. The app is always light with a green
  // top, so: white icons at the top, and a dark gesture bar at the bottom
  // over the light page. (iPhone does this in Info.plist.)
  if (Capacitor.getPlatform() === "android") {
    SystemBars.setStyle({ style: SystemBarsStyle.Dark, bar: SystemBarType.StatusBar }).catch(() => {});
    SystemBars.setStyle({ style: SystemBarsStyle.Light, bar: SystemBarType.NavigationBar }).catch(() => {});
  }
  clearExportCache();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
